<template>
  <div>
    <BaseHero>
      <div class="hero-body">
        <h1 class="title">SPONSORS</h1>
        <h2 class="subtitle">
          Looking to upgrade your gear? Check out one of our awesome sponsors
          below!
        </h2>
      </div>
    </BaseHero>
    <section class="sponsors">
      <div class="container">
        <div class="columns is-multiline has-text-centered">
          <div class="column is-4">
            <div
              data-aos="fade-up"
              data-aos-delay="150"
              class="gi-card has-text-centered"
            >
              <center>
                <img src="@/assets/sponsors/logitechg.svg" alt="" />
              </center>
              <p>
                Logitech G obsesses over every detail to give you the best
                gaming mice, keyboards, headsets, racing wheel and controllers
                to take your gaming to the next level.
              </p>
              <br />
              <a
                href="https://t.co/cFFr05vDmk"
                class="button is-secondary is-fullwidth"
                >Visit Site</a
              >
            </div>
          </div>
          <div class="column is-4">
            <div
              data-aos="fade-up"
              data-aos-delay="250"
              class="gi-card has-text-centered"
            >
              <center><img src="@/assets/sponsors/elgato.svg" alt="" /></center>

              <p>
                Elgato is the leading provider of hardware and software for
                content creators, leveraging decades of experience to develop
                widely-accessible products that empower all creators to produce
                high-quality, professional content.
              </p>
              <br />
              <a
                href="https://bit.ly/2D6j7WR"
                class="button is-secondary is-fullwidth"
                >Visit Site</a
              >
            </div>
          </div>
          <div class="column is-4">
            <div
              data-aos="fade-up"
              data-aos-delay="350"
              class="gi-card has-text-centered"
            >
              <center>
                <img src="@/assets/sponsors/arozzi-logo.png" alt="" />
              </center>
              <p>
                Arozzi is a Swedish company founded in 2013 with focus on
                ergonomic chairs and other productivity enhancing items for
                gamers, high performance PC users, coders and others.
                <br /><br />
                Use code "<span style="color: goldenrod">Gi</span>" at checkout
                for 10% off!
              </p>
              <br />
              <a
                href="https://arozzi.com"
                class="button is-secondary is-fullwidth"
                >Visit Site</a
              >
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import BaseHero from "@/components/BaseHero";
export default {
  name: "Contact",
  components: { BaseHero },
};
</script>

<style lang="scss" scoped>
$gi-card-border-radius: 8px;
$yt-card-border-radius: 8px;
.sponsors {
  padding-top: 5rem;
  min-height: 100vh;
}
@media only screen and (max-width: 43.75em) {
  .sponsors {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
.gi-card {
  background: #0d0c10;
  border: 2px solid darken($color: #bf9c5a, $amount: 20);
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  padding: 1.5rem;
  text-align: left;
  // box-shadow: #9e8425 0px 1px 2px;
  h1,
  h2 {
    color: #d6b439;
  }
  img {
    max-width: 250px;
    margin-bottom: 2rem;
  }
  p {
    font-size: 1.2rem;
    letter-spacing: 0.02rem;
    font-weight: 300;
    cursor: default;
  }
}
</style>
